// @flow
import { getCreator, postCreator } from '../../http';
import environment from '../../environment';
import { of } from 'rxjs';
import type { Country } from '../../entities';

export type PostOrderItemApiReq = {
  url: string;
  name: string;
  categoryId: number;
  image?: string;
  imageURI?: string;
  amount: number;
  price: string;
  originalPackaging: boolean;
  weight: string;
  detail?: string;
};

export type PostOrderApiReq = {
  items: PostOrderItemApiReq[];
  purchaseCountry: Country;
  deliveryCountry: Country;
  deliveryMethod: string;
  deliveryDays: number;
  contactInformation?: {
    firstName: string;
    lastName: string;
    idNumber: string;
    phone: string;
  };
  shippingAddress?: {
    country: Country;
    admin1: number;
    admin2: number;
    admin3: number;
    address1: string;
    address2?: string;
    idNumber?: string;
    name?: string;
    phone?: string;
    zipCode?: string;
  };
  address_id?: string;
};

export const endpoints = Object.freeze({
  UPLOAD_IMAGE: `${environment.apiUrl}/image/upload`,
  UPLOAD_IMAGE_URL: `${environment.apiUrl}/image/upload/url`,
  SEARCH_ADMIN1: `${environment.apiUrl}/meta/location/admin1`,
  SEARCH_ADMIN2: `${environment.apiUrl}/meta/location/admin2`,
  POST_ORDER: `${environment.apiUrl}/order/`,
  GET_LAST_CONTACT_INFO: `${environment.apiUrl}/order/shipping/last`,
});

export const uploadImageApi = postCreator(fetch, endpoints.UPLOAD_IMAGE);
export const uploadImageURLApi = postCreator(fetch, endpoints.UPLOAD_IMAGE_URL);
export const postOrderApi = postCreator(fetch, endpoints.POST_ORDER);
export const getLastContactInfoApi = getCreator(fetch, endpoints.GET_LAST_CONTACT_INFO);



// WEBPACK FOOTER //
// ./src/modules/new-order/api.js